<template>
  <div class="view">
    <div class="content">
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="头像">
            <template slot-scope="scope">
              <div class="td_img">
                <img :src="scope.row.avatar" alt width="60" height="60"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="昵称"></el-table-column>
          <el-table-column prop="mobile" label="手机"></el-table-column>
          <el-table-column prop="order_num" label="成交订单数"></el-table-column>
          <el-table-column prop="deal_money" label="成交金额"></el-table-column>
          <el-table-column prop="all_commission" label="总佣金"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="checkemployee(scope.row.id)">查看</el-button>
            </template>
          </el-table-column> 
        </el-table>
        <div class="pag_wrap" v-if="total!==0">
          <el-pagination background layout="prev, pager, next" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <personaldetail 
            :visible.sync="addcheckemployeedialog"
            :employeeId="employeeId"
    ></personaldetail>    
  </div>
</template>
<script>
  import api from "@/api.js";
  import personaldetail from "@/components/dialog/personalCommissionDetail.vue";
  export default {
    name: "personalCommission",
    components: {
      personaldetail
    },
    data() {
      return {
        tableData: [],
        page: 1,
        total: 1,
        addcheckemployeedialog: false,
        employeeId: ""
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.financial_person, {page: this.page})
            .then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.list
                this.total = response.data.all_page
              } else {
              }
            })
            .catch(response => {
            });
      },
      checkemployee(option) {
        this.employeeId = option;
        this.addcheckemployeedialog = true;
      }
    }
  };
</script>
